import * as React from 'react';
import { observer } from 'mobx-react';

import { EstimateStore } from '../../stores/estimate.store';
import { lazyInject } from 'src/estimate/ioc';
import { SignatureImage } from './signature-image/signature-image';
import { SignatureText } from './signature-text/signature-text';
import { RouterStore } from 'src/core/stores/router.store';
import { UIStatusStore } from 'src/core/stores/ui-status.store';

interface Props {
    bundleId: string;
    estimateId: string;
    closeSignEstimate: () => void;
}

@observer
export class SignEstimateContainer extends React.Component<Props> {
    @lazyInject(EstimateStore) private estimateStore!: EstimateStore;
    @lazyInject(RouterStore) private router!: RouterStore;
    @lazyInject(UIStatusStore) private uiStatus!: UIStatusStore;

    constructor(props: Props) {
        super(props);
        this.estimateStore.setSignatureSubmitting(false);
    }

    handleClose = () => {
        this.props.closeSignEstimate();
    };

    handleSubmit(signatureText?: string, signatureImage?: string) {
        if (!signatureText && !signatureImage) {
            alert('Please provide your signature.');
            return;
        }
        this.estimateStore.setSignatureSubmitting(true);
        this.estimateStore
            .acceptEstimate(this.props.estimateId, signatureText, signatureImage)
            .then(
                (resp) => {
                    this.router.history.push(
                        `/estimate/${this.props.bundleId}/${this.props.estimateId}/confirm`
                    );
                },
                (err) => {
                    console.log(err);
                    this.router.history.push('/system-down');
                }
            );
    }

    render() {
        const { isSignatureSubmitting } = this.estimateStore;

        return (
            <React.Fragment>
                {
                    this.uiStatus.isTouchDevice ? (
                        <SignatureImage
                            container={this}
                            isTablet
                            isSubmitting={isSignatureSubmitting}
                        />
                    ) : (
                        <SignatureText container={this} isSubmitting={isSignatureSubmitting} />
                    )
                }
                {
                }
            </React.Fragment>
        );
    }
}
